var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Stack } from "syf-component-library/ui/spacing";
import { PAGE_NAME } from "../../../const/analytics";
import triggerVantageAnalytics from "../../../helpers/triggerVantageAnalytics";
import VantageLayout from "../../../layout";
import CreditAffects from "./CreditAffects";
import CreditHeader from "./CreditHeader";
import CreditStaticContent from "./CreditStaticContent";
var CreditScorePage = function (_a) {
    var vantageScoreData = _a.vantageScoreData, vantageEnrolledAccounts = _a.vantageEnrolledAccounts;
    var _b = useState(vantageScoreData), vantageScoreDetails = _b[0], setVantageScoreDetails = _b[1];
    useEffect(function () {
        return triggerVantageAnalytics({
            pageName: PAGE_NAME.VANTAGE_VIEW,
        });
    }, []);
    useEffect(function () {
        if (vantageScoreData) {
            setVantageScoreDetails(vantageScoreData);
        }
    }, [vantageScoreData]);
    return (_jsx(VantageLayout, __assign({ headeri18nKey: "creditScorePage.headerSection.creditScore" }, { children: vantageScoreDetails && (_jsxs(_Fragment, { children: [_jsx(CreditHeader, { enrolledAccountDetails: vantageScoreDetails }), _jsx(Stack, { size: "large" }), _jsx(CreditAffects, { enrolledAccountDetails: vantageScoreDetails }), _jsx(CreditStaticContent, { vantageEnrolledAccounts: vantageEnrolledAccounts })] })) })));
};
export default CreditScorePage;
